import React from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'

import { hasCompanyAgentLogin } from '../../../selectors/selectors'
import PaymentOptions from '../../Summary/Payment/PaymentOptions/PaymentOptions'
import PaymentTabs from '../../Summary/Payment/PaymentTabs/PaymentTabs'
import TotalPrice from '../../Summary/TotalPrice/TotalPrice'
import LinkAddVoucher from '../../voucher/LinkAddVoucher/LinkAddVoucher'
import s from './Payment.module.scss'

export default function Payment() {
  const { t } = useTranslation()
  const companyAgentLogin = useSelector(hasCompanyAgentLogin)

  return (
    <section className={s.payment}>
      {companyAgentLogin && <PaymentOptions />}
      <header>{t('payment.title')}</header>
      <TotalPrice />
      <LinkAddVoucher />
      <PaymentTabs />
    </section>
  )
}
